module.exports = __webpack_public_path__ + "static/media/camera-icon.4365175e.svg";